import { render, staticRenderFns } from "./customNo.vue?vue&type=template&id=2968dc8c&scoped=true&"
import script from "./customNo.vue?vue&type=script&lang=js&"
export * from "./customNo.vue?vue&type=script&lang=js&"
import style0 from "./customNo.vue?vue&type=style&index=0&id=2968dc8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2968dc8c",
  null
  
)

export default component.exports